import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Button } from '@mui/material';
import { getScrollbarStyles } from 'utils/scrollbarStyles';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function TableComponent(props) {
  const { columns, rowsComponent, rawRows } = props || {};
  const [copy, setCopy] = useState(false);

  const handleCopyToClipboard = () => {
    if (!columns?.length || !rawRows?.length) return;

    // Encabezados
    const headers = columns.map((col) => col.headerName).join('\t');

    // Filas
    const rowsText = rawRows
      .map((row) =>
        columns
          .map((col) => {
            const value = row[col.field];
            return value !== undefined ? value : '';
          })
          .join('\t'),
      )
      .join('\n');

    const finalText = `${headers}\n${rowsText}`;

    // Copiar al portapapeles
    navigator.clipboard.writeText(finalText).then(() => {
      setCopy(true);
      setTimeout(() => {
        setCopy(false);
      }, 3000);
    });
  };

  return (
    <Box
      sx={{
        height: '60vh',
        display: 'flex',
        flexDirection: 'column',
        ...getScrollbarStyles(),
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
        <Button
          disabled={copy}
          variant='outlined'
          onClick={handleCopyToClipboard}
          sx={{
            '&:hover': {
              color: 'white',
            },
          }}
        >
          {copy ? (
            <>
              <CheckIcon fontSize='small' />
              Tabla copiada
            </>
          ) : (
            <>
              <ContentCopyIcon fontSize='small' />
              Copiar tabla
            </>
          )}
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table stickyHeader sx={{ minWidth: 250 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              {columns?.map((element, index) => (
                <TableCell
                  key={index}
                  align={element.headerAlign || 'left'}
                  sx={{ fontWeight: 'bold' }}
                >
                  {element.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{rowsComponent}</TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
